import { ServerError } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { refreshAndForward } from "modules/utils/Functions";

const isServerError = (error: any): error is ServerError =>
  error && "statusCode" in error;

const refreshTokenLink = onError(({ networkError, operation, forward }) => {
  if (!networkError || !isServerError(networkError)) return;
  if (networkError.statusCode !== 401) return;
  return refreshAndForward(operation, forward);
});

export default refreshTokenLink;
